"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCross = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconCross = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "m12.707 12 7.146-7.146a.5.5 0 1 0-.707-.708L12 11.293 4.853 4.146a.5.5 0 0 0-.707.708L11.293 12l-7.147 7.146A.502.502 0 0 0 4.5 20a.5.5 0 0 0 .353-.146L12 12.707l7.146 7.147a.5.5 0 0 0 .707 0 .5.5 0 0 0 0-.708z" })] })));
};
exports.IconCross = IconCross;
exports.IconCross.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconCross;
